<template>
  <div class=" ">
    <canvas
        data-ui="mouse-debug"
        class="absolute"
        ref="canvas"
        width="2000"
        height="1000"
        @mousedown="startDrawing"
        @mouseup="stopDrawing"
        @mousemove="draw"
        @mouseleave="stopDrawing">
    </canvas>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  setup() {
    const canvas = ref(null);
    const isDrawing = ref(false);
    const context = ref(null);

    const startDrawing = () => {
      isDrawing.value = true;
    };

    const stopDrawing = () => {
      isDrawing.value = false;
      context.value.beginPath(); // Pfad zurücksetzen
    };

    const draw = (event) => {
      if (!context.value) return;

      const rect = canvas.value.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      if (!isDrawing.value) {
        context.value.strokeStyle = 'red';
      } else {
        context.value.strokeStyle = 'black';
      }

      context.value.lineWidth = 10;
      context.value.lineCap = 'round';
      context.value.lineTo(x, y);
      context.value.stroke();
      context.value.beginPath();
      context.value.moveTo(x, y);
    };

    onMounted(() => {
      context.value = canvas.value.getContext('2d');
    });

    return {
      canvas,
      startDrawing,
      stopDrawing,
      draw,
    };
  }
};
</script>

<style scoped>
canvas {
  border: 1px solid black;
  cursor: crosshair;
}
</style>
